import { render, staticRenderFns } from "./view-buyer-dialog.vue?vue&type=template&id=d5dd1bec&scoped=true"
import script from "./view-buyer-dialog.vue?vue&type=script&lang=js"
export * from "./view-buyer-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-buyer-dialog.vue?vue&type=style&index=0&id=d5dd1bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dd1bec",
  null
  
)

export default component.exports